import { connect } from 'react-redux';
import { updateAllRequestStatusesPostInstall, updateInstalledAppsPostInstall } from '../../actions/Installation/postInstallActions';
import { InstallationLockProvider } from '../AppInstallDialog';
const mapStateToProps = state => ({
  hostInfo: state.configuration.hostInfo,
  hostConfig: state.configuration.hostConfig
});
const mapDispatchToProps = (dispatch, ownProps) => ({
  onInstallSuccess: _ref => {
    let {
      installedApp,
      enableDeprecatedInstallationsGQL
    } = _ref;
    updateInstalledAppsPostInstall(dispatch, ownProps.hostInfo.globalContext, ownProps.hostConfig, enableDeprecatedInstallationsGQL);
    updateAllRequestStatusesPostInstall({
      hostInfo: ownProps.hostInfo,
      appKey: installedApp.details.key,
      appName: installedApp.details.name
    });
  }
});
export const EmceeInstallationLock = connect(mapStateToProps, mapDispatchToProps)(InstallationLockProvider);